import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { BookmarkSVG } from '@common_components/svg/bookmark.svg';

const BookMarkIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <BookmarkSVG/>
    </div>
  );
};

export { BookMarkIcon };
